<template>
  <v-card>
    <v-card-title class="subtitle-1">
      {{ $t('dialogs.settings.changeYourSettings') }}
    </v-card-title>

    <v-card-text>
      {{ $t('dialogs.settings.settingsDesc') }}
    </v-card-text>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container fluid>
        <v-row>
          <v-col cols="6" sm="12" md="6">
            <v-text-field
              v-model="userEmail"
              disabled
              :label="$t('dialogs.profile.form.email')"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="12" md="6">
            <v-text-field
              v-model="displayName"
              :label="$t('dialogs.profile.form.displayName')"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <span class="font-weight-regular">{{ $t('dialogs.profile.membership') }}: </span>
            <span v-if="proPlan" class="font-weight-bold">{{ $t('dialogs.profile.proMembership') }}</span>
            <span v-else class="font-weight-bold">{{ $t('dialogs.profile.freeMembership') }}</span>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn color="red darken-1" text @click="dismiss">
        {{ $t('dialogs.settings.btnDismiss') }}
      </v-btn>

      <v-btn color="green darken-1" text @click="update">
        {{ $t('dialogs.settings.btnUpdate') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ProfileDialog',
  data() {
    return {
      allowGeo: true,
      valid: true,
      displayName: this.$attrs.user.displayName || null,
      proPlan: this.$attrs.user.sub_plan_active || false,
      userEmail: this.$attrs.user.email || null,
      buttonLoading: false
    }
  },
  methods: {
    dismiss() {
      this.displayName = this.$attrs.user.displayName
      this.$emit('closeDialog')
    },
    update() {
      const payload = {}
      payload.displayName = this.displayName
      console.log('Profile payload: ', payload)
      // this.$store.dispatch('settings/updateSettingsData', payload)
      // this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
